import React from 'react';

const GradientText = ({ 
  children, 
  className = '',
  as: Component = 'span',
  shimmer = false 
}) => {
  const shimmerClasses = shimmer 
    ? 'animate-shimmer' 
    : '';

  return (
    <Component 
      className={`
        bg-gradient-to-r from-[#D4AF37] via-[#f5e8b8] to-[#D4AF37] 
        bg-clip-text text-transparent 
        bg-[length:200%_auto]
        ${shimmerClasses}
        ${className}
      `}
    >
      {children}
    </Component>
  );
};

export default GradientText;

